import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/gongdan_ic_shoudong@2x.png'
import _imports_1 from '@/assets/icon/chuku_ic_delete@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-1829e3fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rework" }
const _hoisted_2 = { class: "rework_list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("单据类型")
], -1))
const _hoisted_4 = { class: "rework_list_item_right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("出库仓库")
], -1))
const _hoisted_6 = { class: "rework_list_item_right" }
const _hoisted_7 = { class: "rework_qd" }
const _hoisted_8 = { class: "rework_qd_title" }
const _hoisted_9 = { class: "rework_qd_title_left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "增加出库", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "rework_qd_item" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "rework_qd_item_wl" }
const _hoisted_17 = { class: "rework_qd_item_cate" }
const _hoisted_18 = {
  key: 0,
  class: "green"
}
const _hoisted_19 = {
  key: 1,
  class: "yellow"
}
const _hoisted_20 = {
  key: 2,
  class: "red"
}
const _hoisted_21 = { class: "rework_qd_item_hw" }
const _hoisted_22 = { class: "rework_qd_item_hw_right" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数量：", -1))
const _hoisted_24 = ["onUpdate:modelValue", "onInput"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rework_zw" }, null, -1))

import { onMounted, ref, reactive } from 'vue'
    import { useRouter } from 'vue-router'
    import { Toast } from 'vant'
    import { createForStandard } from '@/apis/WorkOrderAPI'
    import Warehouse from '@/components/newCom/Warehouse.vue'
    import Materials from '@/components/newCom/MaterialsB.vue'
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const Material = ref(null)
    const router = useRouter()
    // 表单数据
    let form = reactive({
        warehouseName: '',
        warehouseId: '',
        type: '',
        typeName: ''
    })

    let columns = ref([
        { name: '销售出库', id: 18 },
        { name: '库存调整', id: 28 },
        { name: '仓库报废', id: 21 }
    ])
    const customFieldName = {
      text: 'name'
    };
    let mIds = ref('')
    let list = ref<Array<any>>([])
    let warehouseShow = ref<boolean>(false)
    let materialsShow = ref<boolean>(false)
    let typeShow = ref<boolean>(false)

    const onConfirm1 = (value: any) => {
        form.typeName = value.name
        form.type = value.id
        typeShow.value = false
    };
    const onCancel = () => {
        typeShow.value = false
    }
    const changeNum = (obj: any) => {
        if (obj.num < 0) {
            obj.num = ''
            return Toast('出库物料数量必须大于0')
        }
        if (obj.num > obj.total) {
            obj.num = ''
            return Toast('出库物料数量不能大于库存数')
        }
    }
    // 获取当天年月日
    const getDay = () => {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return `${year}-${month <= 9 ? `0${month}` : month}-${day <= 9 ? `0${day}` : day}`
    }

    // 提交
    const onConfirm = () => {
        if (!form.type) return Toast('请选择单据类型')
        if (!form.warehouseId) return Toast('请选择出库仓库')
        if (list.value.length === 0) return Toast('至少选择一条出库物料')
        for (let i = 0; i < list.value.length; i++) {
            if (!list.value[i].num || list.value[i].num == '' || list.value[i].num <= 0) {
                return Toast(`第${i + 1}个出库物料数量必须大于0`)
            }
            if (list.value[i].num > list.value[i].total) {
                return Toast(`第${i + 1}个物料数量不能大于库存量！`)
            }
        }
        createForStandard({
            billType: form.type,
            planDate: getDay(),
            origin: 0,
            type: 0,
            warehouseId: form.warehouseId,
            woutBoundDetailBeans: list.value
        }).then(res => {
            if (res.code === 200) {
                Toast.success({message: '出库成功'})
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        })
    }

    // 打开选择物料
    const openMs = () => {
        if (!form.warehouseId) return Toast('请先选择出库仓库')
        const { selected }: any = Material.value
        let ids = list.value.map(item => item.id)
        Material.value.selected = ids
        materialsShow.value = true
    }

    // 删除
    const dele = (index: any) => {
        if (list.value.length === 1) {
            Toast('至少保留一条工装信息')
            return
        }
        list.value.splice(index, 1)
    }
    // 关闭仓库选择弹框
    const close = (): void => {
        warehouseShow.value = false
    }
    // 关闭仓库选择弹框
    const close1 = (): void => {
        materialsShow.value = false
    }
    // 选择仓库回调
    const getValue = (item: any): void => {
        form.warehouseName = item.name
        form.warehouseId = item.id
        list.value = []
        warehouseShow.value = false
    }
    const getValue1 = (item: any): void => {
        item.forEach((row: any) => {
            row.total = row.num
        })
        list.value = [...item, ...list.value]
        materialsShow.value = false
        console.log(list.value)
    }
    
    onMounted(() => {
        // 获取工装信息
        // getLKInfo(route.query.id as string)
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(typeShow) //@ts-ignore
 ? typeShow.value = true : typeShow = true))
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).typeName ? 'black' : '')
          }, _toDisplayString(_unref(form).typeName ? _unref(form).typeName : '请选择'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(warehouseShow) //@ts-ignore
 ? warehouseShow.value = true : warehouseShow = true))
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).warehouseName ? 'black' : '')
          }, _toDisplayString(_unref(form).warehouseName ? _unref(form).warehouseName : '请选择'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(`出库物料清单${_unref(list).length}`), 1)
        ]),
        _createElementVNode("div", {
          class: "rework_qd_title_right",
          onClick: openMs
        }, _hoisted_13)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                class: "rework_qd_item_dele",
                onClick: ($event: any) => (dele(index)),
                src: _imports_1,
                alt: ""
              }, null, 8, _hoisted_15),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", null, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                (item.qualityType === '0')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "合格"))
                  : _createCommentVNode("", true),
                (item.qualityType === '1')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "不良"))
                  : _createCommentVNode("", true),
                (item.qualityType === '2')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "报废"))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, " | " + _toDisplayString(item.procedureName || '-') + " | ", 1),
                _createElementVNode("span", null, _toDisplayString(item.batch || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", null, "出库货位：" + _toDisplayString(item.locationName), 1),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                    onInput: ($event: any) => (changeNum(item)),
                    placeholder: "0"
                  }, null, 40, _hoisted_24), [
                    [_vModelText, item.num]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.unitName), 1)
                ])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _hoisted_25,
    _createElementVNode("div", { class: "rework_footer" }, [
      _createElementVNode("button", {
        class: "rework_footer_submit",
        onClick: onConfirm
      }, "提交")
    ]),
    _createVNode(Warehouse, {
      show: _unref(warehouseShow),
      onClose: close,
      onValue: getValue
    }, null, 8, ["show"]),
    _createVNode(Materials, {
      ref_key: "Material",
      ref: Material,
      show: _unref(materialsShow),
      id: _unref(form).warehouseId.toString(),
      onClose: close1,
      onValue: getValue1
    }, null, 8, ["show", "id"]),
    _createVNode(_component_van_popup, {
      show: _unref(typeShow),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(typeShow) ? (typeShow).value = $event : typeShow = $event)),
      round: "",
      position: "bottom",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: _unref(columns),
          onConfirm: onConfirm1,
          onCancel: onCancel,
          "columns-field-names": customFieldName
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})